export function completeSubmissionTutorial() {
    localStorage.setItem("submissionTutorialCompleted", "true");
}

export function checkForSubmissionTutorialCompletion() {
    var tutorialCompleted = (localStorage.getItem("submissionTutorialCompleted") === "true");
    return tutorialCompleted;
}
